'use strict';

import { join } from 'bluebird';

const angular = require('angular');


export default angular.module('wftOrderFormApp.autoCompleteCompanyGl', [])
  .directive('autoCompleteCompanyGl', function($http, $q, $timeout) {
    return {
      restrict: "A",
      scope: {
        ngModel: '=',
        autoCompleteForm: '=',
        autoCompleteExtraParams: '<',
        autoCompleteRelatedFields: '<',
        autoCompleteOnChange: '&',
        autoCompleteOnClosed: '&'
      },
      link: function(scope, elem) {
        let lastSelectedItem;
        let el = $(elem[0]);

        let arrow = $('<a class="auto-complete-arrow-down"><span class="glyphicon glyphicon-chevron-down"></span></a>');
        arrow.on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          el.trigger('open.xdsoft');
          el.trigger('updateContent.xdsoft');
        });
        el.after(arrow);

        let clear = $('<a class="auto-complete-clear hide">x</a>');
        clear.on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          el.val('');
          el.trigger('focus');
          scope.ngModel = '';
          angular.forEach(scope.autoCompleteRelatedFields, function(field) {
            if(scope.autoCompleteForm[field]) {
              scope.autoCompleteForm[field].$setViewValue(null);
              scope.autoCompleteForm[field].$render();
            }
          });
          if(scope.autoCompleteOnChange) {
            $timeout(function() {
              scope.autoCompleteOnChange();
            }, 500);
          }
        });
        el.after(clear);

        $(window).on('click', function() {
          el.trigger('close.xdsoft');
        });
 
        let getData = function(extraParams) {
          let deferred = $q.defer();
          let params = {
            _pageSize: 'All',
            _selector: 'gl,regionName,companyName',
            _sortBy: 'gl asc'
          };
          if(extraParams) {
            angular.extend(params, extraParams);
          }
          $http.get('/api/types/companies/gls', {
            params: params
          }).then(function(res) {
            deferred.resolve(res.data);
          }, function() {
            deferred.resolve();
          });
          return deferred.promise;
        };

        let getSelected = function(item) {
          let names = [];
          if(item.gl) {
            names.push(item.gl);
          }
          if(item.regionName) {
            names.push(item.regionName);
          }
          if(item.companyName) {
            names.push(item.companyName);
          }
          return names.join(' / ');
        };

        el.autocomplete({
          dropdownWidth: 'auto',
          appendMethod: 'replace',
          showHint: false,
          limit: 1000,
          visibleLimit: 20,
          valid: function () {
            return true;
          },
          source: [
            function(q, add) {
              // if(!q) {
              //   return;
              // }
              getData({keywords: q}).then(function(data) {
                add(data);
              });
            }
          ],
          getTitle: function(item) {
            return getSelected(item);
          },
          getValue: function(item) {
            return getSelected(item);
          },
          minLength: 0
        }).on('open.xdsoft',function(event) {
          // console.log('open.xdsoft');
        }).on('pick.xdsoft',function(event) {
          //console.log('pick.xdsoft');
        }).on('updateContent.xdsoft',function(event) {
          //console.log('updateContent.xdsoft');
        }).on('selected.xdsoft',function(event, selectedItem) {
          //console.log('selected.xdsoft');

          if(selectedItem) {
            clear.removeClass('hide');
          }

          lastSelectedItem = selectedItem;
          scope.ngModel = getSelected(selectedItem);
          
          angular.forEach(scope.autoCompleteRelatedFields, function(field) {
            if(/Ref$/.test(field)) {
              scope.autoCompleteForm[field].$setViewValue(selectedItem._id);
              scope.autoCompleteForm[field].$render();
            } else {
              if(scope.autoCompleteForm[field] && selectedItem[field]) {
                scope.autoCompleteForm[field].$setViewValue(selectedItem[field]);
                scope.autoCompleteForm[field].$render();
              }
            }
          });
          if(scope.autoCompleteOnChange) {
            $timeout(function() {
              scope.autoCompleteOnChange();
            }, 500);
          }
        }).on('close.xdsoft',function(event) {
          //console.log('close.xdsoft');
        }).bind('focus', function(event) {
          if(!event.target.value) {
            clear.addClass('hide');
          }
        });

      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directives/autoCompleteCompanyGl/autoCompleteCompanyGl.directive.js